
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SampleBatch } from '@/modules/analysis/models/analysisRequest';
import { GammaSpecTypeEnum } from '@/modules/analysis/models/gammaSpecEnum';
import { NatureEnum } from '@/modules/analysis/models/natureEnum';

@Component({
  components: {}
})
export default class SampleBatchDetails extends Vue {
  @Prop({ required: true })
  protected value!: SampleBatch;
  protected readonly NatureEnum = NatureEnum;

  protected get natureLabel(): string {
    if (!this.value.nature) {
      return '';
    }
    const natureKey = this.value.nature + 'Label';
    return this.$i18n.t(`common.natures.${natureKey}`).toString();
  }

  protected get natureIcon(): string {
    if (!this.value.nature) {
      return '';
    }

    let natureIcon = '';
    for (const nature of NatureEnum) {
      if (nature.value === this.value.nature) {
        natureIcon = nature.icon;
      }
    }

    return natureIcon;
  }

  protected get gammaSpecText(): string {
    let value = 'N/A';

    if (this.value.analyzes.gammaSpecType === GammaSpecTypeEnum.TIME) {
      const duration = this.$i18n.t(`common.gammaSpecTimeValues.${this.value.analyzes.gammaSpecTimeValue}`).toString();
      value = this.$i18n.t('analysis.SampleBatchDetails.gammaSpec', { duration }).toString();
    } else if (this.value.analyzes.gammaSpecType === GammaSpecTypeEnum.RN_DETECT) {
      value = this.$i18n.t('analysis.SampleBatchDetails.gammaSpecRnDetect').toString();
    } else if (this.value.analyzes.gammaSpecType === GammaSpecTypeEnum.SCANNING) {
      const timeStr = this.value.analyzes.gammaScanTimeValue === 0.5 ? '05' : this.value.analyzes.gammaScanTimeValue;
      const duration = this.$i18n.t(`common.gammaScanTimeValues.${timeStr}`).toString();
      value = this.$i18n.t('analysis.SampleBatchDetails.gammaScan', { duration }).toString();
    }

    return value;
  }

  protected get gammaSpecRnDetectList(): { isActive?: boolean; label: string; value: string }[] {
    return this.value.analyzes.gammaSpecRnValue.filter((item) => {
      return item.isActive !== false;
    });
  }

  protected get radiochemRnDetectList(): { isActive?: boolean; label: string; value: string }[] {
    return this.value.analyzes.radiochemRnValue.filter((item) => {
      return item.isActive !== false;
    });
  }
}
